import { usePlatform } from "components/utils/PlatformContext";
import { AnimatePresence, motion } from "framer-motion";
import useGetImageByPresignedUrl from "hooks/useGetImageByPresignedUrl";
import GeneralSkeleton from "./GeneralSkeleton";
import { CSSProperties } from "react";

interface ImageSkeletonProps {
  src?: string;
  alt?: string;
  className?: string;
  style?: CSSProperties;
}

const ImageSkeleton: React.FC<ImageSkeletonProps> = ({
  src = "",
  alt = "",
  className = "",
  style = {},
}) => {
  // Get the header image
  const [image, state] = useGetImageByPresignedUrl(src, [src]);

  // Get the platform context
  const { logo } = usePlatform();

  return (
    <div className={className}>
      <AnimatePresence>
        {
          // Skeleton
          state === "loading" ? (
            <motion.div
              key="skeleton"
              initial={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.4 }}
              className="absolute inset-0"
            >
              <GeneralSkeleton />
            </motion.div>
          ) : state === "successful" ? (
            // Image
            <img
              src={image && state === "successful" ? (image as string) : logo}
              alt={alt}
              className="w-full h-full object-cover"
              style={style}
            />
          ) : (
            <></>
          )
        }
      </AnimatePresence>
    </div>
  );
};

export default ImageSkeleton;
